
export default {
  maps: {
    pageTitle: 'CycleAI',
    Places: 'Locais',
    isochrones: 'Isócronos',
    placeNameRequired: 'Nome do local requerido',
    altitude: 'Variação de altitude',
    settings: 'Opções',
    toggleAccessibleMode: 'Ativar/desativar o modo de acessibilidade',
    about: 'Sobre o ORS',
    updateSearch: 'Buscar nessa área',
    updateSearchAfterZoomOrCenterChange: 'Atualizar busca depois que o centro é alterado'
  }
}
